import type { NativeAppState, PushNotification } from 'src/types/native';

import platform from '@play-co/gcinstant';
import { Native } from 'src/replicant/native';

export const isPlatformNative = () =>
  platform.osType === 'ANDROID_APP' || platform.osType === 'IOS_APP';

export const restartNativeApp = (forceLogin: boolean) =>
  window.TLNative?.core?.restart(forceLogin);

export const logoutNativeApp = () => window.Native?.login?.logout();

export function openNativeAppStorePage() {
  if (platform.osType === 'ANDROID_APP') {
    window.open(Native.ruleset.googlePlayURL);
  } else if (platform.osType === 'IOS_APP') {
    window.open(Native.ruleset.appStoreURL);
  }
}

export const getLinkOpenUrl = () => window.TLNative?.link?.open;
export const addLinkOpenListener = (listener: (url: string) => void) =>
  window.TLNative?.link?.listen(listener);

export const getAcceptedNotifications = async (): Promise<PushNotification[]> =>
  window.Native?.pushNotifications?.getAccepted?.() ?? [];

export const canDismissNotifications = () =>
  !!window.Native?.pushNotifications?.removeDelivered;

export function dismissNotifications() {
  if (canDismissNotifications()) {
    window.Native.pushNotifications.removeDelivered();
  }
}

type NotificationListener = (notification: PushNotification) => void;
const notificationListeners: NotificationListener[] = [];

export const canAddNotificationListener = () =>
  !!window.Native?.pushNotifications?.addAcceptedListener;
if (canAddNotificationListener()) {
  window.Native.pushNotifications.addAcceptedListener(
    (notification: PushNotification) => {
      [...notificationListeners].forEach((listener) => listener(notification));
    },
  );
}

export function addNotificationListener(
  listener: NotificationListener,
): () => void {
  notificationListeners.push(listener);
  return () => {
    const index = notificationListeners.indexOf(listener);
    notificationListeners.splice(index, 1);
  };
}

type StateListener = (state: NativeAppState) => void;

export function addStateListener(listener: StateListener) {
  window.Native?.app?.addStateListener?.(listener);
}
